import { render, staticRenderFns } from "./dynamics-data.vue?vue&type=template&id=4187eb50&scoped=true&"
import script from "./dynamics-data.vue?vue&type=script&lang=js&"
export * from "./dynamics-data.vue?vue&type=script&lang=js&"
import style0 from "./dynamics-data.vue?vue&type=style&index=0&id=4187eb50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4187eb50",
  null
  
)

export default component.exports